/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteActivityItemRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'
import {DeleteActivityItemResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'


export const deleteActivityItem = (request: DeleteActivityItemRequest, options?: CashRequestOptions) => post<DeleteActivityItemRequest, DeleteActivityItemResponse>("/2.0/cash/delete-activity-item", request, {...options, rejectOnError: true })